import { Button } from "@hortis/ui/button";
import { Dialog, DialogTrigger } from "@hortis/ui/dialog";
import { useMediaQuery } from "@hortis/ui/hooks/media-query";
import { RefreshCw5 } from "@hortis/ui/icons";
import { FolderClosed } from "@hortis/ui/icons/folder-closed";
import { AccessionFieldsFragment } from "generated/graphql";
import { useState } from "react";
import { useAccessRole } from "src/features/permissions/use-access-role";
import { useAccessTokenBasic } from "src/utils/use-access-token";
import { twMerge } from "tailwind-merge";
import { ReinstateDialogContent } from "../components/reinstate-dialog";

export const DeaccessionBanner = ({
  accession,
  className,
  compact = false,
}: {
  accession: AccessionFieldsFragment;
  className?: string;
  compact?: boolean;
}) => {
  const roleUtils = useAccessRole();
  const accessToken = useAccessTokenBasic();
  const [reinstateDialogOpen, setReinstateDialogOpen] = useState(false);
  const isDeaccessioned = accession.deaccessionDate != null;
  const isDesktop = useMediaQuery("lg");

  const fullSize = isDesktop && !compact;

  const canEdit = roleUtils.canEdit;

  return isDeaccessioned && !accession.archived ? (
    <div
      className={twMerge(
        "bg-grey-50 font-medium text-sm text-grey-700 py-1 pl-6 pr-4 flex items-center gap-4 border-b border-grey-200 border-dotted animate-in fade-in slide-in-from-top-2",
        fullSize ? "justify-center" : "justify-between",
        className,
      )}
      data-cy="deaccession-banner"
    >
      <div className="flex items-center gap-2">
        <FolderClosed className="text-grey-600 w-4 h-4" />
        Record is deaccessioned
      </div>
      <div className="flex items-center gap-1">
        {accessToken != null && canEdit && (
          <Dialog
            open={reinstateDialogOpen}
            onOpenChange={setReinstateDialogOpen}
          >
            <DialogTrigger asChild>
              <Button
                variant="secondaryGray"
                size="xs"
                className="hover:bg-grey-100 py-1.5 px-2 border border-grey-200 bg-grey-50 shadow-none"
                startIcon={RefreshCw5}
                data-cy="reinstate-button"
              >
                Reinstate
              </Button>
            </DialogTrigger>
            <ReinstateDialogContent
              accessToken={accessToken}
              accessionId={accession.id}
              onOpenChange={setReinstateDialogOpen}
            />
          </Dialog>
        )}
      </div>
    </div>
  ) : null;
};
